import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ValueChangeEvent } from '@interfaces/form.interface';

@Component({
  selector: 'ark-ui-switch',
  templateUrl: './ui-switch.component.html',
  styleUrls: ['./ui-switch.component.css'],
})
export class UiSwitchComponent  implements OnInit {
  @Input() id!: string;
  @Input() text!: string;

  @Input() checked: boolean = false;

  @Output() selectionChanged = new EventEmitter<ValueChangeEvent>();
  constructor() {}

  ngOnInit() {}

  toggle() {
    this.checked = !this.checked;

    this.selectionChanged.emit({ status: 'VALID', value: this.checked });
  }
}
